import { areFieldsPristine, areAnyFieldsPristine, PASSWORD_VALIDATION_MESSAGE, isPasswordValid } from "@limitless/expert/utils/FieldValidators";
import { isEmailValid } from "@limitless/customer/utils/user-validation/UserValidation";
import { validateFirstName, validateLastName } from "@limitless/expert/utils/validators/AboutFormValidator";
import { isFieldEmpty } from "@limitless/common/utils";
const checkFields = fields => {
  let fieldErrors = {};
  const {
    email,
    firstName,
    lastName,
    password,
    termsOfService,
    ageTerms
  } = fields;
  if (!email.pristine && !isEmailValid(email.value)) {
    fieldErrors.email = "Email address is not valid";
  } else if (!email.pristine && isFieldEmpty(email.value)) {
    fieldErrors.email = "Please enter an email address";
  }
  if (!password.pristine && !isPasswordValid(password.value)) {
    fieldErrors.oldPassword = PASSWORD_VALIDATION_MESSAGE;
  }
  fieldErrors = {
    ...fieldErrors,
    ...validateFirstName(firstName, true)
  };
  fieldErrors = {
    ...fieldErrors,
    ...validateLastName(lastName, true)
  };
  const hasAgreedToTermsAndAge = termsOfService.value && ageTerms.value;
  const isFormInvalid = !(hasAgreedToTermsAndAge && Object.keys(fieldErrors).length === 0 && !areAnyFieldsPristine(fields));
  return {
    isFormInvalid,
    fieldErrors
  };
};
export const validateSignUpFields = fields => {
  if (areFieldsPristine(fields)) {
    return {
      fieldErrors: {},
      isFormInvalid: false
    };
  }
  return checkFields(fields);
};